/* ============================================================
   Líder — Pop-up de saída: 5% OFF na 1ª compra (cupom PRIMEIRACOMPRA)
   Coleta nome/email/WhatsApp e revela o cupom SEM recarregar a página.
   ============================================================ */
(function () {
  'use strict';

  var KEY = 'liderPopup1aCompra';
  var pop = document.querySelector('[data-lider-pop]');
  if (!pop) return;

  try { if (localStorage.getItem(KEY)) return; } catch (e) {}

  var shown = false;
  function markSeen() { try { localStorage.setItem(KEY, '1'); } catch (e) {} }

  function show() {
    if (shown) return;
    try { if (localStorage.getItem(KEY)) return; } catch (e) {}
    shown = true;
    pop.hidden = false;
    requestAnimationFrame(function () { pop.classList.add('is-open'); });
  }

  function close() {
    pop.classList.remove('is-open');
    setTimeout(function () { pop.hidden = true; }, 260);
    markSeen();
  }

  pop.querySelectorAll('[data-lider-pop-close]').forEach(function (el) {
    el.addEventListener('click', close);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !pop.hidden) close();
  });

  // Gatilho desktop: mouse sai pela parte de cima. Celular/reserva: 12s.
  document.addEventListener('mouseout', function (e) {
    if (!e.relatedTarget && e.clientY <= 0) show();
  });
  setTimeout(show, 12000);

  var form = pop.querySelector('.lider-pop__form');
  var formState = pop.querySelector('[data-lider-pop-form-state]');
  var couponState = pop.querySelector('[data-lider-pop-coupon-state]');
  var wpp = pop.querySelector('[data-lider-pop-wpp]');
  var tags = pop.querySelector('[data-lider-pop-tags]');
  var submitted = false;

  function handleSubmit() {
    if (submitted) return;
    if (form && typeof form.checkValidity === 'function' && !form.checkValidity()) {
      if (typeof form.reportValidity === 'function') form.reportValidity();
      return;
    }
    submitted = true;

    var digits = wpp && wpp.value ? wpp.value.replace(/\D/g, '') : '';
    if (tags) tags.value = 'primeira-compra' + (digits ? ', whatsapp-' + digits : '');

    // Revela o cupom IMEDIATAMENTE (nada de esperar / recarregar).
    if (formState) formState.hidden = true;
    if (couponState) couponState.hidden = false;
    markSeen();

    // Salva no Shopify em segundo plano, sem navegar a página.
    if (form) {
      try {
        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' },
          keepalive: true
        }).catch(function () {});
      } catch (e) {}
    }
  }

  if (form) {
    // Botão é type="button" (não envia nativo). Enter também é interceptado.
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      e.stopImmediatePropagation();
      handleSubmit();
    });
    var btn = pop.querySelector('[data-lider-pop-submit]');
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault();
      handleSubmit();
    });
  }

  var copyBtn = pop.querySelector('[data-lider-pop-copy]');
  if (copyBtn) {
    copyBtn.addEventListener('click', function () {
      var codeEl = pop.querySelector('[data-lider-pop-code]');
      var code = codeEl ? codeEl.textContent.trim() : '';
      if (navigator.clipboard && code) {
        navigator.clipboard.writeText(code).catch(function () {});
      }
      copyBtn.textContent = 'Copiado! ✓';
      setTimeout(function () { copyBtn.textContent = 'Copiar código'; }, 2000);
    });
  }
})();
